<div class="grid align-items-center mb-2" data-cy="my-unclaimed-tasks">
	<div class="col-6">
		Select tasks to claim
	</div>
	<div class="col-6 text-right">
		<button
			(click)="claimSelectedTasks()"
			[style]="{'max-width':'150px'}"
			class="p-button-primary"
			icon="pi pi-check"
			label="Claim Selected"
			pButton
		></button>
	</div>
</div>

<div class="custom-card">
	<div *ngIf="isLoading" class="text-center py-4">Loading...</div>
	<div *ngIf="this.isClaiming" class="text-center py-4">Wait...</div>
	<p-table
		data-cy="unclaimed-tasks-table"
		[(selection)]="selectedTasks"
		[paginator]="true"
		[rows]="20"
		[style]="{'font-size':'12px'}"
		[value]="unclaimedTasks"
		showCurrentPageReport="true"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} records"
		dataKey="processId"
		selectionMode="multiple"
	>
		<ng-template pTemplate="header">
			<tr>
				<th>
					<p-tableHeaderCheckbox></p-tableHeaderCheckbox>
				</th>
				<th pSortableColumn="name">Task Name
					<p-sortIcon field="name"></p-sortIcon>
				</th>
				<th pSortableColumn="type">Type
					<p-sortIcon field="type"></p-sortIcon>
				</th>
				<th pSortableColumn="assignedDisplayName">Group Name
					<p-sortIcon field="assignedDisplayName"></p-sortIcon>
				</th>
				<th pSortableColumn="dueDate">Due Date
					<p-sortIcon field="dueDate"></p-sortIcon>
				</th>
			</tr>
		</ng-template>
		<ng-template let-task pTemplate="body">
			<tr>
				<td>
					<p-tableCheckbox [value]="task"></p-tableCheckbox>
				</td>
				<td>{{ task.name }}</td>
				<td>
					<div [ngClass]="[getTaskClass(task.type)]" class="flex align-items-center">{{ handleTaskType(task.type) }}
					</div>
				</td>
				<td>{{ task.assignedDisplayName }}</td>
				<td>{{ task.dueDate |  DateLocalFormat: false  }}</td>
			</tr>
		</ng-template>
		<ng-template pTemplate="emptymessage">
			<tr>
				<td colspan="5">No records found</td>
			</tr>
		</ng-template>
	</p-table>
</div>
